import React, {
    ReactElement,
} from "react";
import { BiTrash } from "react-icons/bi";
import EditableControl from "../../../../components/editable-text/EditableText";
import ExpandingSection from "../../../../components/expanding-section/ExpandingSection";
import { Json } from "./base";
import InputList from "./Input";

export default function WorkflowServiceOptions({ json, onChange, rootJson }: {
    rootJson: Json;
    json: Json[];
    onChange: (current: Json[]) => void;
}): ReactElement {
    const handleChange = (index: number, value: Json) => {
        const copy = [...json];
        copy[index] = { ...copy[index], ...value };
        onChange(copy);
    };
    return (
        <div>

            {json?.map((group, groupIndex) => (
                <ExpandingSection
                    title={group.name as string ?? "New Section"}
                    topRightButton={<BiTrash className="text-light" />}
                    topRightClicked={() => {
                        const copy = [...json];
                        copy.splice(groupIndex, 1);
                        onChange(copy);
                    }}
                >
                    <h5>
                        <EditableControl value={group.title as string} onChange={title => handleChange(groupIndex, { title })} />
                    </h5>
                    <EditableControl
                        value={group.description as string}
                        placeholder="Description"
                        onChange={description => handleChange(groupIndex, { description })}
                    />

                    <div>
                        <InputList
                            rootJson={rootJson}
                            json={(group.options as Json[])?.map(row => row.input as Json) as Json[]}
                            onChange={options => handleChange(groupIndex, { options: options.map(input => ({ input })) })}
                        />
                    </div>

                </ExpandingSection>

            ))}

            <button
                type="button"
                className="btn btn-primary"
                onClick={() => onChange([...(json ?? []), {}])}
            >
                Add Section
            </button>

        </div>
    );
}
